import { LayoutContext } from '@landsbankinn/slices/components/contexts/LayoutContext';
import { useRouter } from 'next/router';
import { useRef, useContext, useEffect } from 'react';

export function useLayout() {
  const router = useRouter();
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollDisabled,
    setScrollDisabled,
    lastScrollPosition,
    setLastScrollPosition,
    isNavigationOpen,
  } = useContext(LayoutContext);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const html = document.querySelector('html');
      if (!ref.current || !html) {
        return;
      }
      if (scrollDisabled) {
        setLastScrollPosition(window.scrollY);
        ref.current!.style.top = `${-window.scrollY}px`;
        html.classList.toggle('is-scroll-disabled', true);
      } else {
        html.classList.toggle('is-scroll-disabled', false);
        ref.current!.style.top = '';
        window.scrollTo(0, lastScrollPosition);
      }
    }
  }, [scrollDisabled]);

  useEffect(() => {
    setScrollDisabled(false);
  }, [router.route]);

  useEffect(() => {
    setScrollDisabled(isNavigationOpen);
  }, [isNavigationOpen]);

  return ref;
}
